module.exports = __webpack_public_path__ + "img/TelefonicaCapWeb-Regular.42c2a702.svg";